import { render, staticRenderFns } from "./MobileTopBar.vue?vue&type=template&id=0bb8040f&scoped=true&lang=pug&"
import script from "./MobileTopBar.vue?vue&type=script&lang=js&"
export * from "./MobileTopBar.vue?vue&type=script&lang=js&"
import style0 from "./MobileTopBar.vue?vue&type=style&index=0&id=0bb8040f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb8040f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
